import React from 'react';
import api from 'controllers/raymanAPI';

function map(item)
{
    return {...item, id: item.anchorID, pictureSrc: api.AR.anchors.picture.downloadUrl(item.anchorID)}
}

async function getData()
{
    let indexed = {};
    let byLocation = {};
    let response = await api.AR.anchors.getAll();
    let data = await response.json();
    data = data.map((item)=>map(item));
    data.forEach(item => {
        indexed[item.anchorID] = item;
        if(Object.keys(byLocation).indexOf(item.locationID.toString()) === -1)
        {
            byLocation[item.locationID] = [];
        }
        byLocation[item.locationID].push(item);
    });
    
    return {array: data, indexed: indexed, byLocation: byLocation};
}

const AnchorsCtx = React.createContext({
    loading: true, 
    data: {
        array: [], 
        indexed: {},
        byLocation: {}
    }, 
    funcs: {
        create: () => {},
        update: () => {},
        delete: () => {},
    }
});

function AnchorsCtxProvider(props)
{

    const [loading, setLoading] = React.useState(true);
    const [data, setData] = React.useState({array: [], indexed: {}, byLocation: {}});

    React.useEffect(() => {
        getData().then(values => {
            setData(values);
            setLoading(false);
        });
    }, []);

    const internalAdd = React.useCallback(async (anchorID) => {
        let tmp = {...data};
        let result = await api.AR.anchors.getSingle(anchorID);
        if(result.ok)
        {
            let item = map(await result.json());
            let index = tmp.array.push(item);
            tmp.indexed[item.id] = tmp.array[index-1];
            setData(tmp);
        }
    }, [data]);

    const internalUpdate = React.useCallback((anchorID, anchorData) => {
        let tmp = {...data};
        Object.keys(anchorData).forEach((key) => {
            tmp.indexed[anchorID][key] = anchorData[key];
        })
        setData(tmp);
    }, [data]);

    const internalDelete = React.useCallback((anchorID) => {
        let tmp = {...data};
        let item = tmp.indexed[anchorID];

        // remove from array
        let index = tmp.array.indexOf(item);
        if(index > -1) tmp.array.splice(index,1);

        delete tmp.indexed[anchorID];

    }, [data]);


    const create = React.useCallback(async (data) => {
        let result = await api.AR.anchors.post(data);
        if(result.ok)
        {
            let newID = (await result.json()).anchorID
            internalAdd(newID);
            return newID;
        }
        else return null;
    }, [internalAdd]);

    const update = React.useCallback(async (anchorID, data) => {
        let result = await api.AR.anchors.updateSingle(anchorID, data);
        if(result.ok) internalUpdate(anchorID, data);

    }, [internalUpdate]);

    const remove = React.useCallback(async (anchorID) => {
        let result = await api.AR.anchors.delete(anchorID);
        if(result.ok) internalDelete(anchorID);
    }, [internalDelete]);

    return <AnchorsCtx.Provider value={{loading: loading, data: {...data}, funcs: {create: create, update: update, delete: remove}}} >
        {props.children}
        </AnchorsCtx.Provider>
}


export {AnchorsCtx, AnchorsCtxProvider};
export {FilesCtx as AnchorFilesCtx} from './files';